import { createAuthClient } from "better-auth/react";

/** same-origin: vite proxies /api/auth/* to the API; cookies flow without CORS. */
export const authClient = createAuthClient({ baseURL: "" });

export const { useSession, signOut } = authClient;

export const signInGoogle = () =>
  authClient.signIn.social({ provider: "google", callbackURL: "/" });

export const signInApple = () =>
  authClient.signIn.social({ provider: "apple", callbackURL: "/" });
